module.exports = __webpack_public_path__ + "static/media/societe-generale.450a204f.svg";